import { OfflineBolt } from '@mui/icons-material';
import type React from 'react';
import styled, { keyframes } from 'styled-components';
import type { IconProps } from './types';

const StyledBolt = styled(OfflineBolt)`
  display: block;
  color: ${({ theme }) => theme.palette.primary.main};
  margin: -3px;
`;

const lightning = keyframes`
  0% {
    transform: rotate(10deg);
  }

  25% {
    transform: rotate(-20deg) scale(1.2);
  }

  50% {
    transform: rotate(10deg) scale(1.2);
  }

  75% {
    transform: rotate(-20deg) scale(1.2);
  }

  100% {
    transform: rotate(10deg);
  }
`;

const LightningOnHover = styled.div`
  &:hover {
    animation: ${lightning} 0.75s ease-in-out;
    animation-duration: infinite;
    animation-iteration-count: 1;
  }
`;

const Wrapper = styled.div`
  margin-left: 5px;
`;

const Entitlement: React.FC<IconProps> = (props) => (
  <Wrapper data-testid="entitlement-icon">
    <LightningOnHover>
      <StyledBolt {...props} />
    </LightningOnHover>
  </Wrapper>
);

export const SecondaryEntitlementIcon = styled(Entitlement)`
  color: ${({ theme }) => theme.palette.secondary.main};
`;

export default Entitlement;
